module.exports = __webpack_public_path__ + "static/img/logo.1460b296.png";